import { Select } from 'antd';
import React, { FC, useContext,  } from 'react';
import { StoreContext } from '../../../store/store';
import { useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';

export function useSelectedDataset(searchID: (id: string) => void) {
  const {
    datasetBriefs,
    searchId,
    selectDataset,
    setSelectDataset,
    selectedSearchId,
    setSelectedSearchId,
  } = useContext(StoreContext);

  const navigate = useNavigate();

  function onChange(id: string) {
    const selectItem = datasetBriefs.find((d) => d.Id === id);
    if (!selectItem) {
      return;
    }
    searchID(id);
    setSelectDataset({ ...selectItem });
    setSelectedSearchId(id);
    navigate(`/metadata/${selectItem.Id}`);
  }

  return {
    selectDataset,
    onChange,
    datasetBriefs,
    searchId,
    selectedSearchId,
  };
}

const SearchBar: FC<{ searchID: (id: string) => void }> = ({ searchID }) => {
  const {
    onChange,
    datasetBriefs,
    selectedSearchId,
  } = useSelectedDataset(searchID);

  const {dropdownSearchbarOpen, setDropdownSearchbarOpen} = useContext(StoreContext)

  return (
    <Select
      open={dropdownSearchbarOpen}
      onDropdownVisibleChange={setDropdownSearchbarOpen}
      showSearch
      value={selectedSearchId === '' ? undefined : selectedSearchId}
      style={{ width: '300px' }}
      placeholder="Search datasets..."
      optionFilterProp="children"
      onChange={onChange}
      suffixIcon={<SearchOutlined />}
      filterOption={(input, option: any) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {datasetBriefs.map((data, index) => {
        return (
          <Select.Option key={data.Id} value={data.Id}>
            {`${index + 1},  ${data.ShortDescription}`}
          </Select.Option>
        );
      })}
    </Select>
  )
}

export default SearchBar;
